exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-item{font-size:inhert}.list-item>a{color:inherit;text-decoration:none !important;padding:12px 15px;display:flex;align-items:center}.list-item>a>.list-item-icon{font-size:1.3em;width:1.3em;height:1.3em;display:inline-flex;justify-content:center;align-items:center;margin-right:12px;box-sizing:border-box}", ""]);

